import React from "react"
import { Link } from "gatsby"
import Modal from 'react-modal';
import Layout from "../components/layout"

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)'
  }
};

export default function About() {
  var subtitle;
  const [modalIsOpen,setIsOpen] = React.useState(false);
  const [mfOpen,setMfOpen] = React.useState(false);
  function openModal() {
    setIsOpen(true);
  }



  function closeModal(){
    setIsOpen(false);
  }

  function openMf(){
    setMfOpen(true);
  }

  function closeMf(){
    setMfOpen(false);
  }
  return (

<Layout >
<div className='fullPage'>
  <div >
  <Modal
          isOpen={modalIsOpen}

          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="Example Modal"
        > <div className='modal'><h1>About Me</h1>
        <p> My name is Emma, I graduated from Pratt Institute with a BFA in sculpture and philosophy, then studied full  stack web development at the Grace Hopper School.
       </p>
       <p> I have always loved fashion and wearable/textile art, one reason I studied sculpture was because of an initial desire to create wearable pieces. I ended up going in a different direction in my art, focusing on performance and the codification of the ways humans move, which led me eventually to develop a fascination with cybernetic studies and then coding.
      </p>
      <p> I'm currently a freelance web developer/designer (for my full resume, head <a href="https://docs.google.com/document/d/1XyDnlVmuPcuJAW7WzRuodM9z4Hc9aKcheYQQj7tv6Go/edit?usp=sharing" target ="_blank">here</a>) but am still trying to figure out what exactly it is I want to do with my life!</p>
      <button onClick={closeModal}>close</button>
    </div></Modal>
  </div>
  <div >
  <Modal
          isOpen={mfOpen}

          onRequestClose={closeMf}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className='modal'><h1>About MF</h1>
        <p>Mold Fashioned is a project that sprung up out of the detritus of my life as most facets of it fell apart due to the shitshow of 2020. </p>
        <p> Holed up in my childhood house, devoid of almost any contact with people outside of my mom and sister (who graciously assisted me in taking some of the pictures that ended up on MF), and dealing with chronic illness and disability that had come to a breaking point at the worst time possible, I got a wicked case of artist's block (that hasn't ended yet). </p>
        <p>
        The only way I could think to create something, anything, was to return to my foundational love of clothes, styling them according to the values I espouse in the MF Instagram bio: "a little utilitarian, a little grotesque, a little sexy, very fucking cool."
        </p>
        <button onClick={closeMf}>close</button>
     </div>
        </Modal>
  </div>

    <button onClick={openModal}>About Me</button>


     <button onClick={openMf}>About MF</button>
 </div>
</Layout>
  )
}

